/**
 * cas-89c4: the workspace an item deep link resolved to and selected.
 *
 * The item resolver (useItemWorkspaceResolver) records its pick here before it
 * switches. The auth bootstrap reads it so that, when the resolver switches
 * while the bootstrap is still loading the workspace list, the bootstrap keeps
 * that validated pick instead of reverting to the persisted default. The pick
 * was authorized server-side (GET /items/:id/resolve), so it holds even for a
 * super admin's non-member workspace (cas-b258).
 *
 * Client-only: module state on the server would be shared across requests and
 * users, so every function is a no-op during SSR. The bootstrap clears the pick
 * once it has honoured it, so a later navigation cannot reuse a stale one.
 */
let pick: string | null = null;

export function noteResolvedWorkspacePick(uid: string): void {
  if (import.meta.server) return;
  pick = uid;
}

export function isResolvedWorkspacePick(uid: string | null | undefined): boolean {
  if (import.meta.server) return false;
  return Boolean(uid) && uid === pick;
}

export function clearResolvedWorkspacePick(): void {
  pick = null;
}
